import { render } from "./App.vue?vue&type=template&id=e1a317ae"
const script = {}

import exportComponent from "/src/Altus.Webapp/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__